import { z } from 'zod';
/**
 * Query schema for GET /api/roadmap/active-sprints and
 * GET /api/roadmap/active-sprints/files (gh#750 batch-1).
 *
 * NOTE: z.coerce.boolean() is FORBIDDEN — it treats any non-empty string as
 * true. Use z.enum(['true','false']).transform() instead.
 */
export const activeSprintsQuerySchema = z.object({
    includeArchived: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => v === 'true'),
});
//# sourceMappingURL=activeSprints.schema.js.map